// TOKEN ACTIONS
export const ADD_TOKEN = "ADD_TOKEN";
export const DELETE_TOKEN = "DELETE_TOKEN";
export const GET_INITIAL_TOKEN = "GET_INITIAL_TOKEN";

// API CALLS ACTIONS
export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";
export const STARTED = "STARTED";
export const DELETE = "DELETE";

//AUTH ACTIONS
export const LOGIN_REQUEEST = "LOGIN_REQUEEST";
export const LOGIN_DETAILS = "LOGIN_DETAILS";

// EVENTLIST
export const EVENT_LIST = "EVENT_LIST";
export const ADD_NEW_EVENT = "ADD_NEW_EVENT";
export const EVENT_START_VALUE = "EVENT_START_VALUE";
export const EVENT_HASMORE_VALUE = "EVENT_HASMORE_VALUE";
export const DELETE_EVENT = "DELETE_EVENT";
export const EDIT_EVENT = "EDIT_EVENT";
export const TOTAL_EVENT = "TOTAL_EVENT";
